module.exports = __webpack_public_path__ + "static/media/royal_sundaram.cffaea54.png";